import styled from 'styled-components';
import BaseSidebar from '@/components/Sidebar';

export const Content = styled.div`
  width: 100%;

  & > div:first-of-type {
    z-index: 1;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 300px);
  }
`;

export const Sidebar = styled(BaseSidebar)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 67px;
  }
`;

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const Section = styled.button`
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
`;

export const SidebarSubtitle = styled.p`
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
